export default {
  // 首页
  Home: {
    meta: {
      title: '首页'
    }
  },
  // 登陆
  Login: {
    meta: {
      title: '登录'
    }
  },
  // 富文本
  RichText: {
    meta: {
      title: '协议'
    }
  },
  // 模式信息
  ModelInfo: {
    meta: {
      title: '模式信息'
    }
  },
  // 选购模式
  ModelChoice: {
    meta: {
      title: '模式选择'
    }
  },
  // 查看排名
  Ranking: {
    meta: {
      title: '查看排名'
    }
  },
  // 交易记录
  Transaction: {
    meta: {
      title: '交易记录'
    }
  },
  // 输入编号
  InputNumber: {
    meta: {
      title: '输入编号'
    }
  },
  // 添加表单
  AddForm: {
    meta: {
      title: '添加表单'
    }
  }
}
